import { render, staticRenderFns } from "./AccountVerifyPhone.vue?vue&type=template&id=5bca4f0b&scoped=true"
import script from "./AccountVerifyPhone.vue?vue&type=script&lang=js"
export * from "./AccountVerifyPhone.vue?vue&type=script&lang=js"
import style0 from "./AccountVerifyPhone.vue?vue&type=style&index=0&id=5bca4f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca4f0b",
  null
  
)

export default component.exports